@if (error) {
  <small
    class="error text-danger"
    @fadeInDown
    [class.error--standalone]="!control"
    >{{ error | translate }}</small
  >
}
<ng-content></ng-content>
